export * from './atoms/index.js';
export * from './molecules/index.js';

const assetsPath = 'https://cdn.nordnet.fr/components/v1/assets/components';
export default assetsPath;
